<template>
    <v-card class="myprofile-popup">
        <v-card-title primary-title>
            {{memberProfileConstants.ABOUT_ME_SECTION.EDIT_MY_FAMILY}}
            <i class="fas fa-times" data-qe-id="close_dialog_btn" @click="cancel(false)"></i>
        </v-card-title>
        <v-card-text class="inner-scrollbar" ref="familyDialogId">
            <v-flex v-for="(familyDetail, index) in AllFamilyDetails" :key="index" class="family-details">
                <v-form v-model="familyDetail.isValid" lazy-validation :ref="`family-${familyDetail.id}`">
                    <v-layout row wrap>
                        <v-flex xs12>
                            <span class="select-required">{{memberProfileConstants.REQUIRED}}</span>
                        </v-flex>
                    </v-layout>
                    <v-layout row wrap>
                        <v-flex xs12 sm6>
                            <v-flex class="form-control">
                                <span class="select-label">{{memberProfileConstants.ABOUT_ME_SECTION.RELATION_TO_YOU}}{{memberProfileConstants.ASTERISK}}</span>
                                <v-select
                                    attach
                                    height="32"
                                    color="ypo_blue"
                                    :data-qe-id="`family-${index}_relation_select`"
                                    :items="relationOptions(familyDetail)"
                                    :placeholder="memberProfileConstants.ABOUT_ME_SECTION.RELATION_TO_YOU"
                                    v-model="familyDetail.recordTypeName"
                                    :rules="memberProfileConstants.ABOUT_ME_SECTION.RELATION_TO_YOU_ERROR"
                                    @input="edit(familyDetail)"
                                    :disabled="isMember(familyDetail)"
                                    required></v-select>
                            </v-flex>
                        </v-flex>
                        <v-flex xs12 sm6 v-if="familyDetail.recordTypeName === memberProfileConstants.CHILD">
                            <v-flex class="form-control">
                                <span class="select-label">{{memberProfileConstants.ABOUT_ME_SECTION.GENDER}}{{memberProfileConstants.ASTERISK}}</span>
                                <v-select
                                    attach
                                    height="32"
                                    color="ypo_blue"
                                    :data-qe-id="`family-${index}_gender_select`"
                                    :items="profileDropDowns.gender"
                                    item-text="gender"
                                    item-value="gender" 
                                    :placeholder="memberProfileConstants.ABOUT_ME_SECTION.GENDER"
                                    v-model="familyDetail.gender"
                                    :rules="memberProfileConstants.ABOUT_ME_SECTION.GENDER_ERROR"
                                    @input="edit(familyDetail)"
                                    :disabled="isMember(familyDetail)"
                                    required></v-select>
                            </v-flex>
                        </v-flex>
                        <v-flex xs12 sm6>
                            <v-flex class="form-control">
                                <span class="select-label">{{memberProfileConstants.ABOUT_ME_SECTION.TITLE_PREFIX}}</span>
                                <v-autocomplete
                                    attach
                                    height="32"
                                    color="ypo_blue"
                                    item-text="prefix"
                                    :data-qe-id="`family-${index}_title_select`"
                                    :items="allPrefixes"
                                    v-model="familyDetail.salutation"
                                    :placeholder="memberProfileConstants.ABOUT_ME_SECTION.TITLE_PREFIX"
                                    :disabled="isMember(familyDetail)"
                                    @input="edit(familyDetail)">
                                </v-autocomplete>
                            </v-flex>
                        </v-flex>
                    </v-layout>
                    <v-layout row wrap>
                        <v-flex xs12 sm6>
                            <v-flex class="form-control">
                                <span class="select-label">{{memberProfileConstants.ABOUT_ME_SECTION.FIRST_OR_GIVEN_NAME}} {{memberProfileConstants.ASTERISK}}</span>
                                <v-text-field
                                    :placeholder="memberProfileConstants.ABOUT_ME_SECTION.FIRST_OR_GIVEN_NAME"
                                    required
                                    color="ypo_blue"
                                    :rules="memberProfileConstants.ABOUT_ME_SECTION.FIRST_OR_GIVEN_NAME_ERROR"
                                    :data-qe-id="`family-${index}_first-name_input`"
                                    v-model="familyDetail.firstName"
                                    :disabled="isMember(familyDetail)"
                                    @input="edit(familyDetail)"
                                    :maxlength="memberProfileConstants.MAXIMUM_LENGTH_FOR_EXTENSION_NUMBER"></v-text-field>
                            </v-flex>
                        </v-flex>
                        <v-flex xs12 sm6>
                            <v-flex class="form-control">
                                <span class="select-label">{{memberProfileConstants.ABOUT_ME_SECTION.MIDDLE_NAME}}</span>
                                <v-text-field
                                    :placeholder="memberProfileConstants.ABOUT_ME_SECTION.MIDDLE_NAME"
                                    v-model="familyDetail.middleName"
                                    :data-qe-id="`family-${index}_middle-name_input`"
                                    color="ypo_blue"
                                    :disabled="isMember(familyDetail)"
                                    @input="edit(familyDetail)"
                                    :maxlength="memberProfileConstants.MYCOMMUNITIES_NETWORK_NAME_MAX_TEXT_LENGTH"></v-text-field>
                            </v-flex>
                        </v-flex>
                        <v-layout row wrap>
                            <v-flex xs12 sm6>
                                <v-flex class="form-control">
                                    <span class="select-label">{{memberProfileConstants.ABOUT_ME_SECTION.LAST_OR_FAMILY_NAME}} {{memberProfileConstants.ASTERISK}}</span>
                                    <v-text-field
                                        :placeholder="memberProfileConstants.ABOUT_ME_SECTION.LAST_OR_FAMILY_NAME"
                                        v-model="familyDetail.lastName"
                                        required
                                        :rules="memberProfileConstants.ABOUT_ME_SECTION.LAST_OR_FAMILY_NAME_ERROR"
                                        :data-qe-id="`family-${index}_family-name_input`"
                                        color="ypo_blue"
                                        :disabled="isMember(familyDetail)"
                                        @input="edit(familyDetail)"
                                        :maxlength="memberProfileConstants.MYCOMMUNITIES_NETWORK_NAME_MAX_TEXT_LENGTH"></v-text-field>
                                </v-flex>
                            </v-flex>
                            <v-flex xs12 sm6>
                                <v-flex class="form-control">
                                    <span class="select-label">{{memberProfileConstants.ABOUT_ME_SECTION.SUFFIX}}</span>
                                    <v-autocomplete
                                        attach
                                        height="32"
                                        color="ypo_blue"
                                        :items="allSuffixes"
                                        item-text="suffix"
                                        :data-qe-id="`family-${index}_suffix_select`"
                                        :disabled="isMember(familyDetail)"
                                        v-model="familyDetail.suffix"
                                        :placeholder="memberProfileConstants.ABOUT_ME_SECTION.SUFFIX"
                                        @input="edit(familyDetail)">
                                    </v-autocomplete>
                                </v-flex>
                            </v-flex>
                        </v-layout>
                    </v-layout>
                    <v-layout row wrap>
                        <v-flex xs12 sm6>
                            <v-flex class="form-control">
                                <span class="select-label">{{memberProfileConstants.EMAIL_ADDRESS}} <em v-if="isSpouse(familyDetail)">{{memberProfileConstants.ASTERISK}} </em></span>
                                <v-text-field
                                    :placeholder="memberProfileConstants.EMAIL_ADDRESS"
                                    :required="isSpouse(familyDetail)"
                                    :rules="isSpouse(familyDetail) ? emailRules : emailRulesValid"
                                    v-model="familyDetail.email"
                                    :data-qe-id="`family-${index}_email_input`"
                                    color="ypo_blue"
                                    :disabled="isMember(familyDetail)"
                                    @input="edit(familyDetail)"
                                    @blur="checkEmailExists(familyDetail)"
                                    :loading="getEmailExistsAction && getEmailExistsAction.pending"
                                    ref="emailAddress"></v-text-field>
                            </v-flex>
                        </v-flex>
                        <v-flex xs12 sm6>
                            <v-flex class="form-control">
                                <span class="select-label">{{memberProfileConstants.ABOUT_ME_SECTION.CONFIRM_EMAIL_ADD}} <em v-if="isSpouse(familyDetail)"> {{memberProfileConstants.ASTERISK}} </em></span>
                                <v-text-field
                                    :placeholder="memberProfileConstants.ABOUT_ME_SECTION.CONFIRM_EMAIL_ADD"
                                    :required="isSpouse(familyDetail)"
                                    :rules="isSpouse(familyDetail) ? emailRules : emailRulesValid"
                                    color="ypo_blue"
                                    :disabled="isMember(familyDetail)"
                                    :data-qe-id="`family-${index}_confirm-email_input`"
                                    v-model="familyDetail.confirmEmailAddress"
                                    @input="edit(familyDetail)"
                                    @paste="$event.preventDefault()"></v-text-field>
                                <span class="email-valid__validation" v-if="familyDetail.isValid && invalidConfirmEmail">{{memberProfileConstants.EMAIL_CONFIRM_EMAIL_DIFFERENT}}</span>
                            </v-flex>
                        </v-flex>
                    </v-layout>
                    <v-layout row wrap>
                        <v-flex xs12 sm6>
                            <v-flex class="form-control">
                                <span class="select-label">{{memberProfileConstants.ABOUT_ME_SECTION.DATE_OF_BIRTH}}</span>
                                <v-menu
                                    :ref="familyDetail.datePickerMenu" class="calander-icon"
                                    :close-on-content-click="false"
                                    :data-qe-id="`family-${index}_date-of-birth_menu`"
                                    :nudge-right="40"
                                    lazy
                                    v-model="familyDetail.datePickerMenu"
                                    transition="scale-transition"
                                    offset-y
                                    full-width
                                    :disabled="isMember(familyDetail)"
                                    min-width="290px"
                                    max-width="290px">
                                    <v-text-field
                                        slot="activator"
                                        v-model="familyDetail.birthdate"
                                        prepend-inner-icon="event"
                                        :disabled="isMember(familyDetail)"
                                        @input="edit(familyDetail)"
                                        :data-qe-id="`family-${index}_date-of-birth_txt`"
                                        clearable
                                        required
                                        readonly>
                                    </v-text-field>
                                    <v-date-picker
                                        ref="picker"
                                        @input="familyDetail.datePickerMenu = false,edit(familyDetail)"
                                        v-model="familyDetail.birthdate"
                                        :max="new Date().toISOString().substr(0, 10)"
                                        min="1900-01-01"
                                        :data-qe-id="`family-${index}_date-of-birth_datepicker`"
                                        :disabled="isMember(familyDetail)">
                                    </v-date-picker>
                                </v-menu>
                            </v-flex>
                        </v-flex>
                    </v-layout>
                    <v-layout row wrap v-if="isSpouse(familyDetail)">
                        <v-flex xs6>
                            <v-flex class="form-control">
                                <v-checkbox
                                    :disabled="isMember(familyDetail)"
                                    @change="edit(familyDetail)"
                                    :data-qe-id="`family-${index}_has-ypo-access_checkbox`"
                                    v-model="familyDetail.hasYpoExchangeAccess"
                                    :label="memberProfileConstants.ABOUT_ME_SECTION.SPOUSE_ACCESS">
                                </v-checkbox>
                            </v-flex>
                        </v-flex>
                    </v-layout>
                    <v-layout
                        row
                        wrap
                        class="check-list"
                        v-if="familyDetail.uniqueEmail || !familyDetail.isValid">
                        <v-flex class="form-control">
                            <span v-if="!familyDetail.uniqueEmail && !familyDetail.isValid"  class="required-field" :data-qe-id="`family-${index}_warning`">
                                {{memberProfileConstants.REQUIRED_FIELD_WARNING}}
                            </span>
                            <span v-if="familyDetail.uniqueEmail" class="required-field" :data-qe-id="`family-${index}_warning`">
                                {{memberProfileConstants.EMAIL_FIELD_WARNING}}
                            </span>
                        </v-flex>
                    </v-layout>
                    <v-layout row wrap>
                        <v-flex class="btn-row">
                            <v-btn
                                class="primary_btn"
                                v-if="!familyDetail.isEditDialog"
                                :data-qe-id="`family-${index}_add-more_btn`"
                                :disabled="!familyDetail.isAdd || isMember(familyDetail) || invalidConfirmEmail"
                                @click="addFamilyDetails(familyDetail)">
                                <i class="fas fa-plus-circle mr-2"></i>{{memberProfileConstants.ADD_MORE}}
                            </v-btn>
                            <v-btn
                                small
                                class="primary_btn"
                                @click="deleteFamilyDetails(familyDetail.id, index)"
                                :data-qe-id="`family-${index}_delete-member_btn`"
                                :disabled="familyDetail.isDelete">
                                <i class="fas fa-trash-alt mr-2"></i>{{appCommonConstants.DELETE}}
                            </v-btn>
                            <v-flex class="save-to-profile" :data-qe-id="`family-${index}_success_text`" v-model="familyDetail.isSuccess" v-if="familyDetail.isSuccess">
                                <i class="fas fa-check"></i> <span>{{memberProfileConstants.SAVED_TO_PROFILE}}</span>
                            </v-flex>
                        </v-flex>
                    </v-layout>
                    <v-dialog
                        v-model="deleteInformationDialog"
                        lazy
                        absolute
                        content-class="post-actions">
                        <v-card>
                            <v-flex tag="h6">{{memberProfileConstants.DIALOG_CONFIRMATION_TITLE}}
                                <v-btn icon data-qe-id="close_dialog_icon" @click="deleteInformationDialog=false">
                                    <v-icon size="20">close</v-icon>
                                </v-btn>
                            </v-flex>
                            <v-flex tag="p">{{memberProfileConstants.DIALOG_CONFIRMATION_DESC}}</v-flex>
                            <status-bar :action="deleteRelationshipAction"></status-bar>
                            <v-flex text-xs-right>
                                <v-btn flat data-qe-id="cancel_dialog_btn" @click="deleteInformationDialog = false" class="primary_btn transparent">
                                    {{memberProfileConstants.CANCEL}}
                                </v-btn>
                                <v-btn dark data-qe-id="save_dialog_btn" id="delete_continue_btn" @click="deleteInformation()" class="primary_btn">
                                    {{memberProfileConstants.CONTINUE}}
                                </v-btn>
                            </v-flex>
                        </v-card>
                    </v-dialog>
                </v-form>
            </v-flex>
        </v-card-text>
        <status-bar :action="saveRelationshipsAction"></status-bar>
        <status-bar :action="updateRelationshipAction"></status-bar>
        <v-card-actions>
            <v-flex text-xs-right pa-3>
                <v-btn flat class="primary_btn transparent" data-qe-id="cancel_dialog_btn" @click="cancel(false)">
                    {{appCommonConstants.CANCEL}}
                </v-btn>
                <v-btn class="primary_btn" data-qe-id="save_dialog_btn" id="save_dialog_btn" :disabled="!(AllFamilyDetails && AllFamilyDetails[0].isValid) || !isSaveLocal || invalidConfirmEmail || isAllUniqueEmail || (getEmailExistsAction && getEmailExistsAction.pending)" @click="saveFamilyDetails()">
                    {{appCommonConstants.DONE}}
                </v-btn>
            </v-flex>
        </v-card-actions>
    </v-card>
</template>

<script>
import { memberProfileConstants } from "../memberProfile.constants.js";
import { mapActions, mapGetters, mapState } from "vuex";
import { storeAction } from "../../../store/storeActions.constant";
import { storeGetters } from "../../../store/storeGetters.constant";
import { appCommonConstants } from "../../appCommon.constants.js";
import { uuid } from 'vue-uuid';
import Vue from 'vue';
import StatusBar from "../../StatusBar/StatusBar";

export default {
    name: "FamilyMember",
    data: () => ({
        memberProfileConstants,
        appCommonConstants,
        uuid: uuid.v1(),
        birthdate: null,
        familyId: null,
        familyDeleteIndex: null,
        deleteInformationDialog: false,
        invalidConfirmEmail: false,
        isSaveLocal: false,
        isAllUniqueEmail: false,
        updateUniqueEmail: 0,
        existingEmail: [],
        emailRules: [
            v => !!v || memberProfileConstants.VALID_EMAIL_ADDRESS,
            v => /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(v) || memberProfileConstants.INVALID_EMAIL_ADDR,
        ],
        emailRulesValid: [
            v => !v || /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(v) || memberProfileConstants.INVALID_EMAIL_ADDR,
        ],
    }),
    components: {
        StatusBar,
    },
    props: {
        AllFamilyDetails: {
            type: Array,
            required: false,
        },
        familyDetail: {
            type: Object,
            required: false,
        },
        memberType: {
            type: String,
            required: false,
        },
        isFamilyEditDialog: {
            type: Boolean,
            required: false,
        },
        isSave: {
            type: Boolean,
            required: false,
        },
        hasSpouse: {
            type: Boolean,
            required: false,
        },
        isMemberSpouse: {
            type: Boolean,
            required: false,
        },
        memberId: {
            type: String,
            required: true,
        },
        familyDetails: {
            type: Object,
            required: false,
        },
    },
    created() {
        this.emailRules.push(v => !this.existingEmail.includes(v) || this.memberProfileConstants.VALID_EMAIL_ADDRESS);
        this.emailRulesValid.push(v => !this.existingEmail.includes(v) || this.memberProfileConstants.VALID_EMAIL_ADDRESS);
    },
    methods: {
        ...mapActions({
            updateRelationship: `memberProfile/${storeAction.updateRelationship}`,
            saveRelationships: `memberProfile/${storeAction.saveRelationships}`,
            deleteRelationship: `memberProfile/${storeAction.deleteRelationship}`,
            getEmailExists: `memberProfile/${storeAction.getEmailExists}`,
        }),
        edit(familyDetail) {
            familyDetail.isEdit = true;
            if (this.isSpouse(familyDetail)) {
                if (familyDetail.email && familyDetail.confirmEmailAddress && familyDetail.firstName &&
                    familyDetail.lastName && familyDetail.recordTypeName) {
                    this.isSaveLocal = true;
                    familyDetail.isAdd = true;
                }
            } else if (familyDetail.firstName && familyDetail.lastName && familyDetail.recordTypeName) {
                if ( familyDetail.recordTypeName === this.memberProfileConstants.CHILD && !familyDetail.gender)
                {
                    this.isSaveLocal = false;
                    familyDetail.isAdd = false;
                } else {
                    this.isSaveLocal = true;
                    familyDetail.isAdd = true;
                }
                }
            if (familyDetail.recordTypeName === this.memberProfileConstants.SPOUSE) {
                familyDetail.isSpouseSelected = true;
                familyDetail.portalAccessLevel = familyDetail.hasYpoExchangeAccess === true ? this.memberProfileConstants.SPOUSE_PARTNER_ACCESS_TYPE : null;
            } else {
                familyDetail.isSpouseSelected = false;
            }
            this.invalidConfirmEmail = familyDetail.email && (familyDetail.email !== familyDetail.confirmEmailAddress);
        },
        addFamilyDetails(familyDetail) {
            let familyCategory;
            const familyDetailForSave = familyDetail;
            const [ref] = this.$refs[`family-${familyDetail.id}`];
            if (ref && ref.validate && ref.validate()) {
                familyDetailForSave.isEditDialog = false;
                familyDetailForSave.id = this.generateGUID();
                familyDetailForSave.isEdit = false;
                familyDetailForSave.gender = this.getGender(familyDetailForSave);
                familyDetailForSave.name = this.getFullName(familyDetailForSave);
                familyDetailForSave.memberId = this.memberId;
                const myJson = { "Member": [], "Spouse/Partner": [], "Child": [] };
                familyCategory = this.familyMemberType(familyDetailForSave.recordTypeName);
                myJson[familyCategory].push(familyDetailForSave);
                this.familyDetails.Member[0].memberId = this.memberId;
                myJson.Member.push(this.familyDetails.Member[0]);
                const postBody = {
                    ...myJson,
                };
                this.saveRelationships(postBody)
                    .then((response) => {
                        if (response && response.data && response.data.message === this.memberProfileConstants.EMAIL_ALREADY_EXIST) {
                            this.spouseEmailValidations();
                        } else {
                            ref.resetValidation();
                            familyDetailForSave.isDelete = false;
                            familyDetailForSave.isAdd = true;
                            familyDetailForSave.isSuccess = true;
                            familyDetailForSave.isEditDialog = true;
                            const index = this.AllFamilyDetails.length;
                            //takes a bit for dom to actually update
                            setTimeout(() => {
                                if (document.getElementById(index)) {
                                document.getElementById(index).scrollIntoView();
                                }
                            }, 100);
                            this.familyDetail.id = this.generateGUID();
                            this.AllFamilyDetails.push(Vue.util.extend({}, this.familyDetail));
                        }
                    });
            }
        },
        deleteFamilyDetails(familyId, index) {
            this.deleteInformationDialog = true;
            this.familyId = familyId;
            this.familyDeleteIndex = index;
        },
        deleteInformation() {
            const parms = {
                relationshipId: this.familyId,
                personId: this.memberId,
            };
            this.deleteRelationship(parms)
                .then(() => {
                    if (this.familyDeleteIndex <= 0 && this.AllFamilyDetails.length === 1) {
                        this.$emit('click', false);
                    } else {
                        Vue.delete(this.AllFamilyDetails, this.familyDeleteIndex);
                    }
                    this.scrollTop();
                    this.deleteInformationDialog = false;
                });
        },
        saveFamilyDetails() {
            let familyCategory;
            if (this.isFamilyEditDialog) {
                const [ref] = this.$refs[`family-${this.AllFamilyDetails[0].id}`];
                if (ref && ref.validate && ref.validate()) {
                    familyCategory = this.familyMemberType(this.AllFamilyDetails[0].recordTypeName);
                    this.AllFamilyDetails[0].gender = this.getGender(this.AllFamilyDetails[0]);
                    this.AllFamilyDetails[0].name = this.getFullName(this.AllFamilyDetails[0]);
                    const myJson = {};
                    /* eslint prefer-destructuring: ["error", {VariableDeclarator: {object: true}}] */
                    myJson[familyCategory] = this.AllFamilyDetails[0];
                    myJson[familyCategory].memberId = this.memberId;                    
                    const postBody = {
                        ...myJson,
                    };
                    this.updateRelationship(postBody)
                        .then((response) => {
                            if (response && response.data && response.data.message && response.data.message.includes(this.memberProfileConstants.EMAIL_ALREADY_EXIST)) {
                                this.spouseEmailValidations();
                            } else {
                                ref.resetValidation();
                                this.$emit('click', false);
                                this.scrollTop();
                                this.AllFamilyDetails[0].uniqueEmail = false;
                                this.updateUniqueEmail = new Date().getTime();
                            }
                        });
                }
            } else {
                const [ref] = this.$refs[`family-${this.AllFamilyDetails[0].id}`];
                if (ref && ref.validate && ref.validate()) {
                    const myJson = { "Member": [], "Spouse/Partner": [], "Child": [] };
                    this.AllFamilyDetails.forEach((member) => {
                        member.gender = this.getGender(member);
                        member.name = this.getFullName(member);
                        member.memberId = this.memberId;
                        if (member.isEdit === true) {
                            if (member.id === null) {
                                member.id = this.generateGUID();
                            }
                            familyCategory = this.familyMemberType(member.recordTypeName);
                            const list = myJson[familyCategory];
                            if (list) {
                                list.push(member);
                            } else {
                                myJson[familyCategory] = [member];
                            }
                        }
                    });
                    this.familyDetails.Member[0].memberId = this.memberId;
                    myJson.Member.push(this.familyDetails.Member[0]);
                    this.saveRelationships(myJson)
                        .then((response) => {
                            if (response && response.data && response.data.message === this.memberProfileConstants.EMAIL_ALREADY_EXIST) {
                                this.spouseEmailValidations();
                            } else {
                                ref.resetValidation();
                                this.$emit('click', false);
                                this.scrollTop();
                            }
                        });
                }
            }
        },
        generateGUID() {
            return uuid.v1();
        },
        save(date) {
            this.$refs.menu.save(date);
        },
        cancel(value) {
            this.isSaveLocal = true;
            this.resetValidation();
            this.$emit('click', value);
            this.scrollTop();
        },
        resetValidation() {
            this.AllFamilyDetails.forEach((x) => {
                const [ref] = this.$refs[`family-${x.id}`];
                if (ref && ref.resetValidation) {
                    ref.resetValidation();
                }
            });
        },
        familyMemberType(memberType) {
            return memberType === this.memberProfileConstants.SPOUSE ?
                memberType :
                this.memberProfileConstants.CHILD;
        },
        getGender(familyDetail) {
            return familyDetail.gender;
        },
        isSpouse(familyDetail) {
            return familyDetail.recordTypeName === this.memberProfileConstants.SPOUSE;
        },
        relationOptions(familyDetail) {
            return (this.hasSpouse && !familyDetail.isSpouseSelected) || this.isMemberSpouse ?
                [this.memberProfileConstants.CHILD] :
                [this.memberProfileConstants.SPOUSE, this.memberProfileConstants.CHILD];
        },
        getFullName(familyDetail) {
            return `${familyDetail.firstName} ${familyDetail.lastName}`;
        },
        scrollTop() {
            if (this.$refs.familyDialogId) {
                this.$refs.familyDialogId.scrollTop = 0;
            }
        },
        isMember(familyDetail) {
            return familyDetail.recordTypeName === this.memberProfileConstants.MEMBER;
        },
        spouseEmailValidations() {
            this.AllFamilyDetails[0].uniqueEmail = true;
            this.AllFamilyDetails[0].confirmEmailAddress = '';
            if (this.$refs.emailAddress && this.$refs.emailAddress[0] && this.$refs.emailAddress[0].focus) {
                this.$refs.emailAddress[0].focus();
            }
            this.updateUniqueEmail = new Date().getTime();
        },
        checkEmailExists(familyDetail) {
            if (!familyDetail.email) {
                familyDetail.uniqueEmail = false;
                this.updateUniqueEmail = new Date().getTime();
                return true;
            } 
            if (this.AllFamilyDetails.filter(x => x.email && x.email.toLowerCase() === familyDetail.email.toLowerCase()).length > 1) {
                familyDetail.uniqueEmail = true;
                this.updateUniqueEmail = new Date().getTime();
                return true;
            }
            const postBody = {
                personId: familyDetail.id,
                email: familyDetail.email,
            };
            this.getEmailExists(postBody)
                .then((response) => {
                    familyDetail.uniqueEmail = response.data;
                    this.updateUniqueEmail = new Date().getTime();
                    if (response && response.data === true) {
                        this.existingEmail.push(familyDetail.email);
                        this.$refs.emailAddress[0].focus();
                        if (this.$refs[`family-${familyDetail.id}`][0] && this.$refs[`family-${familyDetail.id}`][0].validate) {
                            this.$refs[`family-${familyDetail.id}`][0].validate();
                        }
                    }
                });
        },
    },
    computed: {
        ...mapGetters({
            currentUserId: `memberProfile/${storeGetters.currentUserId}`,
            allPrefixes: `memberProfile/${storeGetters.allPrefixes}`,
            allSuffixes: `memberProfile/${storeGetters.allSuffixes}`,
            chapterAdminEditable: `memberProfile/${storeGetters.chapterAdmin}`,
            profileDropDowns: `memberProfile/${storeGetters.profileDropDowns}`,
        }),
        ...mapState("actionState", ["actions"]),
        isCurrentUser() {
            return this.memberId === this.currentUserId || this.chapterAdminEditable;
        },
        saveRelationshipsAction() {
            return this.actions[storeAction.saveRelationships];
        },
        updateRelationshipAction() {
            return this.actions[storeAction.updateRelationship];
        },
        deleteRelationshipAction() {
            return this.actions[storeAction.deleteRelationship];
        },
        getEmailExistsAction() {
            return this.actions[storeAction.getEmailExists];
        },
    },
    watch: {
        isSave(val) {
            if (val) {
                this.isSaveLocal = val;
            }
        },
        menu(val) {
            if (val) {
                this.$nextTick(() => {
                    this.$refs.picker.activePicker = 'YEAR';
                });
            }
        },
        updateUniqueEmail(val) {
            if (val) {
                this.isAllUniqueEmail = this.AllFamilyDetails.some(x => !!x.uniqueEmail);
            }
        },
    },
};
</script>

<style lang="scss">
@import "../../../common/styles/_colors.scss";

.family-details {
    border-bottom: 2px solid $ypo-gray;
    margin-bottom: 20px;

    &:last-child {
        border-bottom: none;
        margin-bottom: 0;
    }

    .select-required {
        color: $ypo-blue;
        font-size: 14px;
        font-weight: bold;
        line-height: 20px;
        margin-left: 600px;
        @media (max-width: 767px){
            display: none;
        }
    }

    .v-input--selection-controls__input {
        &+.v-label {
            font-size: 14px;
            font-weight: 400;
            color: $ypo-gray-text !important;
        }
        top: -5px;
    }

    .email-valid {
        position: relative;
        &__validation {
            position: absolute;
            color: $ypo-deep-red;
            font-size: 12px;
            bottom: 0;
        }
    }
}

.myprofile-popup .form-control.select-full-width {
    .v-select__selections {
        overflow: hidden;
    }

    .v-select__selection--comma {
        text-overflow: ellipsis;
        white-space: nowrap;
        overflow: hidden;
        display: block;
    }

    .v-list__tile__content {
        overflow: auto;
    }

    .v-list__tile {
        height: auto;
    }

    .v-list__tile__title {
        overflow: auto;
        white-space: inherit;
        word-break: break-word;
        height: auto;
        margin-bottom: 10px;
    }
}
.required-field {
    font-style: italic;
    color: $ypo-deep-red;
    font-size: 13px;
    margin-left: 200px;
}

.check-list {
    border-bottom: none !important;
}
</style>
